import React, { Component } from 'react';

const $PLST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/static`);

class Spinner extends Component {
  render() {
    const { centerOfPage, className = '' } = this.props;
    return (
      <div
        className={`spinner ${
          centerOfPage ? 'center-of-page' : ''
        } ${className}`}
        {...this.props}
      >
        <img src={$PLST.SPINNER} width='32' height='32' alt='' />
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/theme/Spinner.js